export default __webpack_public_path__ + "static/GRID22-map-disasters-fr-446240683ea59f50d516b2d8e9b60c6e.png";